module.exports = __webpack_public_path__ + "media/images/recrutare/recrutare_medici_logo-4349b7344313dc8654637aa023ffdea6.png";